import { useEffect, useState } from 'react';
import { Table, Input, Button, Tag, message, Space, Popconfirm } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

export default function AdminBusinesses() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      const r = await api.get('/admingov/businesses', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { setPage(1); fetchData(1); /* eslint-disable-next-line */ }, [search]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/businesses/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Biznes nomi', dataIndex: 'name', render: v => <span style={{ fontWeight: 600 }}>{v || '—'}</span> },
    { title: 'STIR', dataIndex: 'stir', render: v => v || <Tag color="red">Yo'q</Tag> },
    { title: 'Egasi', dataIndex: 'owner_name', render: v => v || '—' },
    { title: 'Telefon', dataIndex: 'owner_phone', render: v => v || '—' },
    { title: 'Viloyat', dataIndex: 'region', render: v => v || '—' },
    { title: 'Status', dataIndex: 'status', render: v => <Tag color={v === 1 ? 'green' : 'red'}>{v === 1 ? 'Aktiv' : 'Nofaol'}</Tag> },
    {
      title: 'Amal', width: 70, fixed: 'right',
      render: (_, r) => (
        <Popconfirm title="O'chirishni tasdiqlaysizmi?" okText="Ha" cancelText="Yo'q" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div className="admin-toolbar">
        <Input placeholder="Nomi yoki STIR bo'yicha qidirish" prefix={<SearchOutlined />} allowClear
          value={search} onChange={e => setSearch(e.target.value)} style={{ width: 320 }} />
        <span style={{ marginLeft: 'auto', color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{total}</b></span>
      </div>
      <div className="admin-table-card">
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="middle" scroll={{ x: 780 }}
          pagination={{ current: page, total, pageSize: 20, showSizeChanger: false,
            onChange: p => { setPage(p); fetchData(p); } }} />
      </div>
    </div>
  );
}
